export const password = {
  validate(value) {
    const pattern = /^(?=.*?[a-z])(?=.*?\d)/
    return value ? pattern.test(value) : true
  },
  message(field) {
    return `${field}には英字と数字の両方を含んでください`
  },
}
